export const AccordionVariant = {
  STANDARD: 0,
  SECTION_WITH_CHIP: 1,
  CTA_STANDARD: 2,
  CTA_WITH_HEAD_DESCRIPTION: 3,
};
